import React from "react";
import {View, Text, StyleSheet} from "react-native";
import firebase from "./Firebase";

class AboutMe extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            about: "",
        }
    }

    componentWillMount() {
        var that =this;
        // Getting the list of projects from the firebase ref
        firebase.database().ref('About/whoami').on('value', function(data){
            that.setState({about: data.val()});
            
        })
    }
    render(){
        const AboutComponent =()=>{

            return(
                <View style = {styles.container}>
                    <Text style= {styles.heading}>
                        who am i<mark style={{backgroundColor: '#2D3047', color: 'white', borderRadius: 5}}>?</mark>
                    </Text>
                    <Text style ={styles.normalText}>
                        {this.state.about}
                    </Text>
                </View>
            )
        }
        return(
            <AboutComponent/>
        )
    }

}
const styles = StyleSheet.create({
    container:{
        width: "100%",
        // marginTop: 15,
    },
    heading: {
        fontWeight: 'bold',
        fontSize: 22,
        fontFamily: 'Monospace',
        marginVertical: 10,
        color: '#2D3047',
    },
    normalText:{
        fontSize: 16,
        marginBottom: 10,
    }
})


export default AboutMe;


// WEBPACK FOOTER //
// ./src/AboutMe.js